import React, { useState } from "react";
import { BASE_BUTTON_CLASS, SCREEN_TYPE } from "../constants/common";
import { classnames, getTimeInSeconds } from "../utils/general";

const InfoScreen = ({ screenType, onClick, screenData, gameData }) => {
  const {
    upperDescription,
    title,
    lowerDescription,
    buttonText,
    image
  } = screenData;

  const [loading, setLoading] = useState(false);

  const isHtml = /<\/?[a-z][\s\S]*>/i.test(lowerDescription);
  const textClass = `text-gold-hue w-[84%] leading-8 text-base font-['IBM Plex Sans']
    tracking-[-0.7px] font-normal text-[#C9C4B8] whitespace-pre-wrap w-3/5`;
  const checkDisplayEndTime = gameData?.displayEndTime;
  const checkGameProblemTitle = (screenType === SCREEN_TYPE.START && gameData?.problem?.title) || screenType === SCREEN_TYPE.END;
  const checkDisplayEndTimeValidity = checkDisplayEndTime && ((gameData.endTime - getTimeInSeconds()) > 0);
  
  return (
    <div className="h-[100vh] w-full flex items-center justify-center">
      <div className="py-10 w-[80%] flex items-center justify-center">
        {
          checkGameProblemTitle ?
          <div className="w-[60%] h-[640px] flex flex-col items-start justify-start">
            <span
              className="mt-16 text-sm text-[#C1BDB5] font-medium tracking-tight"
            >
              {upperDescription}
            </span>
            <h2 className={classnames(
              `problem-header pt-20 pb-6 leading-[1.1]
              text-6xl text-white font-medium font capitalize overflow-visible w-4/5`,
              `${screenType === SCREEN_TYPE.START ? 'whitespace-pre-wrap' : '' }`
            )}
            >
              {screenType === SCREEN_TYPE.START ? 
                gameData?.problem?.title
                : title
              }
            </h2>
            {
              isHtml ? (
                <div
                  className={textClass}
                  dangerouslySetInnerHTML={{ __html: isHtml ? lowerDescription: null }}
                />
              ) : (
                <pre 
                  className={textClass}
                >
                  {lowerDescription}
                </pre>
              )
            }
            {
              screenType === SCREEN_TYPE.START && checkDisplayEndTime && 
              <div className="flex items-center justify-center mt-6 p-2 border-white border-2">
                <h3 className="text-xl text-white mr-4">Test Valid Until</h3>
                <p className={classnames(
                  `leading-[1.1]
                  text-xl font-medium font capitalize overflow-visible`,
                  `${checkDisplayEndTimeValidity ? 'text-green-100': 'text-red-500'}`
                  )}
                >
                  {checkDisplayEndTime}
                </p>
              </div>              
            }
            <button
              className={classnames(
                BASE_BUTTON_CLASS,
                `${loading ? "cursor-not-allowed opacity-50": ""}`,
                "mt-16 px-16 py-[14px]",
              )}
              onClick={() => {
                if (screenType === SCREEN_TYPE.END) setLoading(true);
                onClick();
              }}
              disabled={loading}
            >
              {buttonText}
            </button>
            {loading && 
              <p 
                className={classnames(
                  "relative left-4",
                  "text-lg leading-[30px] tracking-[-0.5px] text-gold-hue", 
                  "sm:text-base mt-2 text-center"
                )}
              >
                Submitting ...
              </p>
            }
          </div>
          :
          (<div className="w-[60%] h-[640px] flex flex-col items-center justify-center">
            <div className="box"><span className="loader"></span></div>
          </div>
          )
        }
        
        <div className="max-w-[40%] h-full flex items-center justify-center">
          <img
            className="w-[450px] h-[640px] rounded-[20px]" 
            src={image} 
            alt="Info Screen Image"
            />
        </div>
      </div>      
    </div>
  );
};

export default InfoScreen;

